export default "__VITE_ASSET__xpKp3Und__"